module.exports = __webpack_public_path__ + "img/across front.270e6a36.png";